import { render, staticRenderFns } from "./TabsNavigation.vue?vue&type=template&id=e64b2518&scoped=true&"
import script from "./TabsNavigation.vue?vue&type=script&lang=ts&"
export * from "./TabsNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./TabsNavigation.vue?vue&type=style&index=0&id=e64b2518&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64b2518",
  null
  
)

export default component.exports